import { createFileRoute } from "@tanstack/react-router";
import { AuthCallback } from "@/auth/AuthCallback";

// Dedicated public OIDC redirect target. Keycloak returns the authorization code
// here; AuthCallback finishes the exchange and forwards the user on. Deliberately
// kept out of the `_authenticated` tree so it renders while the visitor is still
// anonymous, mid code-exchange.
export const Route = createFileRoute("/auth/callback")({
  component: AuthCallback,
});
